<template>
  <el-dialog
      title="切换用户"
      :visible.sync="dialogVisible"
      width="400px"
      :close-on-click-modal="false"
      @close="handleDialogClose">
    <el-form :model="form" label-width="80px">
      <el-form-item label="用户名">
        <el-input 
            v-model.trim="form.userName" 
            placeholder="请输入用户名"
            @keyup.enter.native="confirm"/>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="confirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import auth from "@/util/loginUtil";

  export default {
    name: "ChangeUser",
    data() {
      return {
        dialogVisible: false,
        form: {
          userName: "",
        },
        loading: false,
      };
    },
    methods: {
      // 打开对话框
      open() {
        this.dialogVisible = true;
      },
      // 确认切换用户
      confirm() {
        if (!this.form.userName) {
          this.$message.error("请输入用户名");
          return;
        }

        this.loading = true;

        this.$http.post("basic", "account/changeLogin", {
          userName: this.form.userName,
        }).then((res) => {
          if (res.success) {
            // 更新本地用户信息
            auth.login(res.data);
            this.$message.success("切换用户成功");
            this.dialogVisible = false;

            // 刷新当前页面
            this.$nextTick(() => {
              location.reload();
            });
          }
        }).finally(() => {
          this.loading = false;
        });
      },
      // 对话框关闭回调
      handleDialogClose() {
        this.form.userName = "";
      },
    },
  };
</script>
